const Title = () => {
  return (
    <div className="wavy-text">
      <h1 className="logo">Croissance</h1>
      <h2 className="title">La Boulangerie des leaders</h2>
    </div>
  );
}
 
export default Title;